module.exports = __webpack_public_path__ + "img/content-title.f1e600dd.png";